import React from 'react';
import './Glance.css';

const Cobrowse = (props: { url?: string }) => {
  const keyName = `GLANCE_COBROWSE_${Math.floor(Math.random() * 1000)}`;

  return (
    <iframe
      src={props.url}
      className={'glance-cobrowse-iframe'}
      title="Cobrowse"
      referrerPolicy="no-referrer-when-downgrade"
      allowFullScreen
      allow="camera *;microphone *"
    />
  );
};

export default Cobrowse;
